export default "__VITE_ASSET__BgOBs$Kp__"